module.exports = __webpack_public_path__ + "img/8.cdd8403c.png";